import { NavLink } from 'react-router';
import { trackEvent } from '@/shared/lib/analytics';

interface TabConfig {
  to: string;
  label: string;
  icon: (active: boolean) => React.ReactNode;
}

const IconBooks = ({ active }: { active: boolean }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={active ? 2.1 : 1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

const IconShelf = ({ active }: { active: boolean }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={active ? 2.1 : 1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="3" width="7" height="18" rx="1" />
    <rect x="10" y="3" width="4" height="18" rx="1" />
    <rect x="15" y="3" width="7" height="18" rx="1" />
  </svg>
);

const IconUser = ({ active }: { active: boolean }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={active ? 2.1 : 1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const tabs: TabConfig[] = [
  {
    to: '/catalog',
    label: 'Каталог',
    icon: (active) => <IconBooks active={active} />,
  },
  {
    to: '/my-clubs',
    label: 'Мои клубы',
    icon: (active) => <IconShelf active={active} />,
  },
  {
    to: '/profile',
    label: 'Профиль',
    icon: (active) => <IconUser active={active} />,
  },
];

export function MiniappTabBar() {
  return (
    <nav
      aria-label="Основная навигация"
      className="pointer-events-none fixed inset-x-0 bottom-0 z-40"
    >
      <div className="pointer-events-auto mx-auto w-full max-w-[var(--shell-frame-max-width)] px-[var(--shell-inline-pad)]">
        <div
          className="mx-auto w-full max-w-[var(--screen-max-width)] px-[var(--page-gutter)]"
          style={{ paddingBottom: 'calc(var(--safe-area-bottom) + var(--tab-bar-safe-gap))' }}
        >
          <div className="h-[var(--tab-bar-visual-height)] rounded-[var(--tab-shell-radius)] border border-[rgba(26,26,26,0.06)] bg-[rgba(247,244,237,0.92)] p-[var(--tab-bar-body-padding)] shadow-[0_1px_2px_rgba(26,26,26,0.05)] min-[430px]:rounded-[var(--tab-shell-radius-comfortable)]">
            <div className="grid h-full grid-cols-3 gap-1">
              {tabs.map(({ to, label, icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  onClick={() => trackEvent('tab_click', { tab: to })}
                  className={({ isActive }) =>
                    [
                      'flex h-full flex-col items-center justify-center gap-0.5 rounded-[var(--tab-radius)] px-2 py-1.5 transition-[background-color,color,border-color] min-[430px]:rounded-[var(--tab-radius-comfortable)]',
                      isActive
                        ? 'border border-[rgba(26,26,26,0.05)] bg-[rgba(255,255,255,0.72)] text-[rgba(26,26,26,0.88)]'
                        : 'border border-transparent text-[rgba(26,26,26,0.48)] hover:bg-[rgba(255,255,255,0.52)]',
                    ].join(' ')
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className={isActive ? 'text-[rgba(26,26,26,0.92)]' : 'text-current'}>
                        {icon(isActive)}
                      </span>
                      <span
                        className={[
                          'text-[var(--tab-label-size)] leading-none min-[430px]:text-[var(--tab-label-size-comfortable)]',
                          isActive
                            ? 'font-medium tracking-[0.01em]'
                            : 'font-medium tracking-[0.005em]',
                        ].join(' ')}
                      >
                        {label}
                      </span>
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
